<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(request)">
        <b-row>
          <b-col md="6" class="mb-3">
            <input-form
                v-model="info.email"
                placeholder="Ex: name@coflow.com"
                :validate="'required|email'"
                name="Facility Email Address"
                :label="'Facility Email Address'"
                disabled
            />
          </b-col>

          <b-col md="6" class="mb-3">
            <input-form
                v-model="info.full_name"
                placeholder="Ex: Eslam Ashraf"
                :validate="'required|max:20'"
                name="Full Name"
                :label="'Full Name'"
                :limit="20"
                disabled
            />
          </b-col>

          <b-col md="4" class="mb-3">
            <input-form
                v-model="info.gender"
                placeholder="Ex: Male"
                :validate="'required'"
                name="Gender"
                :label="'Gender'"
                disabled
            />
          </b-col>

          <b-col md="4" class="mb-3">
            <input-form
                v-model="info.phone"
                placeholder="Ex: 0123456789"
                :validate="'required|numeric|digits:11'"
                name="Phone"
                :label="'Phone'"
                disabled
            />
          </b-col>

          <b-col md="4" class="mb-3">
            <b-form-group label="Experience" label-for="experience">
              <flatPickr
                  :class="['form-control bg-white']"
                  v-model="instructorRequest.experience"
                  placeholder="Select Start Date"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Activity Tags -->
        <div
            v-for="(item, index) in instructorRequest.activity_tags"
            :key="index"
        >
          <b-row  class="position-relative">
            <b-col md="6" class="mb-2">
              <main-select
                  labelTitle="Activity Line"
                  :validate="'required'"
                  :name="`activity_line_id_${index}`"
                  placeholder="Choose"
                  :options="getFilteredActivityLines(index)"
                  label="name"
                  :reduce="data => data.id"
                  v-model="item.activity_line_id"
                  @input="getAllTags(item.activity_line_id, index)"
              />
            </b-col>

            <b-col md="6" class="mb-2">
              <main-select
                  labelTitle="Choose Tags"
                  :validate="'required'"
                  :multiple="true"
                  :name="`tags_${index}`"
                  placeholder="Search"
                  :options="item.tagsOptions"
                  label="name"
                  :reduce="data => data.id"
                  v-model="item.tag_ids"
              />
            </b-col>
            <span class="text-danger deleteLabelButton cursor-pointer" v-if="index !==0" style="top:0px; right: 5px"  @click="removeActivityTag(index)">Delete
            </span>
          </b-row>
        </div>
        <p class="d-flex justify-content-end m-0">
          <span class="text-warning cursor-pointer" @click="addActivityTag">+ Add New Activity Tag</span>
        </p>


        <b-row v-if="status === 'new'">
          <b-col md="12" class="mt-4">
            <p v-if="requestLoading" class="text-center">
              <spinner-loading text="Loading" />
            </p>

            <div
                class="d-flex justify-content-center gap_10"
                v-else
            >
              <b-button
                  v-if="hasPer('lead.accept')"
                  class="container_button_blue ml-2"
                  @click="selectedStatus = 'accepted'"
                  type="submit"
              >
                <span>ACCEPT</span>
              </b-button>

              <b-button
                  v-if="hasPer('lead.reject')"
                  class="gradient-orange-button box_orange_shadow"
                  @click="selectedStatus = 'rejected'"
                  type="submit"
              >
                <span>REJECT</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import settingsService from '@/modules/superAdmin/settings/services/settings.services'

export default {
  props: {
    requestLoading: {
      type: Boolean,
      default: false
    },

    instructorDetails: {
      type: Object,
      required: false
    }
  },

  components: {
    flatPickr
  },

  data () {
    return {
      allActivityLines: [],

      selectedStatus: null,

      info: {
        email: '',
        full_name: '',
        gender: '',
        phone: '',
        center_name: '',
        facebook_link: '',
        instagram_link: '',
        whatsapp_link: '',
      },

      instructorRequest: {
        experience: null,

        activity_tags: [
          {
            activity_line_id: null,
            tag_ids: [],
            tagsOptions: []
          }
        ],

        status: null
      },

      status: ''
    }
  },

  methods: {
    request () {
      const payload = {
        experience: this.instructorRequest.experience,

        activity_tags: this.instructorRequest.activity_tags.map(item => ({
          activity_line_id: item.activity_line_id,
          tag_ids: item.tag_ids
        })),

        status: this.selectedStatus
      }
      this.$emit('request', payload)
    },

    addActivityTag () {
      this.instructorRequest.activity_tags.push({
        activity_line_id: null,
        tag_ids: [],
        tagsOptions: []
      })
    },

    removeActivityTag (index) {
      this.instructorRequest.activity_tags.splice(index, 1)
    },

    getAllActivityLine () {
      settingsService.getAllActivityLine().then(res => {
        this.allActivityLines = res.data.data
      })
    },

    getAllTags (activityLineId, index) {
      this.instructorRequest.activity_tags[index].tag_ids = []

      settingsService.getAllTags(activityLineId).then(res => {
        this.instructorRequest.activity_tags[index].tagsOptions = res.data.data
      })
    },

    getFilteredActivityLines (currentIndex) {
      const selectedIds = this.instructorRequest.activity_tags
          .map((item, index) => {
            if (index !== currentIndex) {
              return item.activity_line_id
            }
          })
          .filter(Boolean)

      return this.allActivityLines.filter(
          item => !selectedIds.includes(item.id)
      )
    }
  },

  created () {
    this.getAllActivityLine()

    if (this.instructorDetails) {
      this.info = {
        email: this.instructorDetails.email,
        full_name: this.instructorDetails.full_name,
        gender: this.instructorDetails.gender,
        phone: this.instructorDetails.phone,
        center_name: this.instructorDetails.center_name,
        facebook_link: this.instructorDetails.facebook_link,
        instagram_link: this.instructorDetails.instagram_link,
        whatsapp_link: this.instructorDetails.whatsapp_link,
      }

      this.status = this.instructorDetails.status
    }
  }
}
</script>